import produce from 'immer';
import { capitalize } from 'lodash';
import { memo } from 'react';

import { useTrackToggledFieldRequiredStatus } from '@air/analytics';
import { type Form, type FormField } from '@air/api/types';
import { TypeIcon } from '@air/design-icons';

import { CollectionFormField } from '~/components/Modals/ContentCollectionModal/CollectionFormField';
import { useUpdateForm } from '~/swr-hooks/forms/useUpdateForm';

type SettingsItemProps = {
  formField: FormField;
  form: Form;
};
export const SettingsItem = memo(({ formField, form }: SettingsItemProps) => {
  // biome-ignore lint/suspicious/noUnnecessaryConditions: PLA-1724 — pre-existing debt, not introduced by the icon migration
  const fieldName = capitalize(formField?.type);
  const required = formField.required || false;
  const disabled = formField.type === 'title' || form.autoSubmit === true;

  const { trackToggledFieldRequiredStatus } = useTrackToggledFieldRequiredStatus();
  const { updateForm } = useUpdateForm();

  return (
    <CollectionFormField
      // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
      onSelect={async (required: boolean) => {
        const updatedFields = produce(form.fields, (draft) => {
          const fieldToUpdate = draft?.find(({ type }) => formField.type === type);

          // biome-ignore lint/style/useBlockStatements: PLA-1724 — pre-existing debt, not introduced by the icon migration
          if (fieldToUpdate) draft?.splice(draft?.indexOf(fieldToUpdate), 1, { ...fieldToUpdate, required: required });
        });

        await updateForm({
          ...form,
          fields: updatedFields,
        });

        trackToggledFieldRequiredStatus({ fieldName: 'Description', required });
      }}
      fieldName={fieldName}
      required={required}
      disabled={disabled}
      leftAdornment={<TypeIcon className="text-gray-10" size="sm" />}
    />
  );
});

SettingsItem.displayName = 'SettingsItem';
